var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAnoLiturgico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_ano_liturgico",
    transform: "translate(-0.648 -0.648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_202",
    "data-name": "Rect\\xE1ngulo 202",
    width: 25,
    height: 25,
    transform: "translate(0.648 0.648)",
    fill: "rgba(255,255,255,0)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "aLwPqg.tif",
    transform: "translate(2.356 3.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_982",
    "data-name": "Grupo 982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_437",
    "data-name": "Trazado 437",
    d: "M21.822,5.8h.44a.316.316,0,0,0,.06.041.939.939,0,0,1,.659.957c0,.09,0,.181,0,.273A4.356,4.356,0,0,1,23.5,7.1a1.026,1.026,0,0,1,.763.7V23a1.115,1.115,0,0,1-1.206.727c-4.319-.014-8.639-.008-12.958-.008q-2.68,0-5.36,0a.929.929,0,0,1-.961-.935q0-7.387,0-14.774a.932.932,0,0,1,.929-.928c.112,0,.223,0,.363,0a3.16,3.16,0,0,1,0-.515,1.03,1.03,0,0,1,.7-.766h.44a.4.4,0,0,0,.063.04.929.929,0,0,1,.662.94c0,.1,0,.194,0,.3h13.01a1.165,1.165,0,0,1,.2,0,.285.285,0,0,1,.263.3.276.276,0,0,1-.268.293,2.167,2.167,0,0,1-.24.006H6.941c0,.144,0,.256,0,.369a.941.941,0,0,1-1.882-.023c0-.111,0-.222,0-.337-.068,0-.106-.008-.145-.008-.432-.007-.536.094-.536.52V9.63H23.662c0-.536,0-1.056,0-1.575a.343.343,0,0,0-.348-.363c-.1-.009-.208,0-.331,0,0,.141,0,.259,0,.378a.935.935,0,0,1-.934.9.92.92,0,0,1-.945-.887c-.011-.46-.007-.919,0-1.379a.883.883,0,0,1,.459-.77C21.643,5.883,21.734,5.846,21.822,5.8Zm1.84,4.469H4.377V22.585c0,.444.092.536.54.536h18.2c.45,0,.542-.092.542-.535V10.272ZM6.338,7.4c0-.206,0-.412,0-.619A.352.352,0,0,0,6,6.408a.345.345,0,0,0-.339.351q-.012.628,0,1.257A.338.338,0,1,0,6.338,8C6.341,7.8,6.338,7.6,6.338,7.4ZM21.7,7.386c0,.206,0,.412,0,.618a.338.338,0,0,0,.324.359.335.335,0,0,0,.349-.336c.011-.426.01-.852,0-1.277a.342.342,0,0,0-.345-.342.347.347,0,0,0-.328.359C21.7,6.974,21.7,7.18,21.7,7.386Z",
    transform: "translate(-3.777 -5.803)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_438",
    "data-name": "Trazado 438",
    d: "M17.269,24.415h1.317V20.048c0-.341.1-.436.442-.437h1.789V18.3H19.812c-.287,0-.573,0-.86,0a.326.326,0,0,1-.365-.374c0-.54,0-1.08,0-1.62v-.233H17.269v.807c0,.32,0,.64,0,.96,0,.377-.083.461-.453.462H15.04v1.3c.071,0,.141.01.212.01.54,0,1.08,0,1.621,0,.3,0,.395.1.4.4,0,.28,0,.56,0,.84a.308.308,0,0,1-.29.34.314.314,0,0,1-.312-.341c0-.2,0-.4,0-.617-.51,0-1,0-1.493,0a1.189,1.189,0,0,1-.3-.034.6.6,0,0,1-.453-.587c0-.414,0-.826,0-1.24a.633.633,0,0,1,.669-.682c.446-.006.893,0,1.34,0h.233v-1.5a.656.656,0,0,1,.748-.746c.367,0,.734,0,1.1,0a.629.629,0,0,1,.683.667c.006.446,0,.893,0,1.34v.235c.523,0,1.022-.006,1.52,0a.961.961,0,0,1,.4.088.6.6,0,0,1,.326.578c0,.4.008.8,0,1.2a.641.641,0,0,1-.7.676c-.506,0-1.012,0-1.548,0v.246q0,1.889,0,3.779c0,.554-.222.778-.77.778-.374,0-.747,0-1.121,0a.622.622,0,0,1-.639-.628q-.007-1.11,0-2.22a.3.3,0,0,1,.306-.321.29.29,0,0,1,.295.309c0,.053,0,.107,0,.16v2.082Z",
    transform: "translate(-7.701 -9.356)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_439",
    "data-name": "Trazado 439",
    d: "M27.918,21.644c-.146,0-.293.005-.439,0a.3.3,0,0,1-.331-.3.294.294,0,0,1,.312-.316c.312-.011.624-.01.937,0a.31.31,0,0,1,.316.316.319.319,0,0,1-.337.3C28.223,21.649,28.07,21.644,27.918,21.644Z",
    transform: "translate(-12.392 -11.413)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_440",
    "data-name": "Trazado 440",
    d: "M11.165,21.026c.153,0,.306-.008.458,0a.3.3,0,0,1,.314.314.3.3,0,0,1-.329.3q-.448.01-.9,0a.313.313,0,0,1-.339-.314.317.317,0,0,1,.334-.3c.152-.008.306,0,.458,0Z",
    transform: "translate(-6.208 -11.414)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_441",
    "data-name": "Trazado 441",
    d: "M13.359,23.872a1.025,1.025,0,0,1-.107.223,3.884,3.884,0,0,1-.336.34.29.29,0,0,1-.427-.009.285.285,0,0,1,0-.412,1.859,1.859,0,0,1,.357-.344.425.425,0,0,1,.328-.026C13.253,23.671,13.3,23.792,13.359,23.872Z",
    transform: "translate(-6.956 -12.372)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_442",
    "data-name": "Trazado 442",
    d: "M26.771,24.537a1.124,1.124,0,0,1-.222-.115,4.158,4.158,0,0,1-.338-.337.3.3,0,0,1,0-.415.3.3,0,0,1,.414-.017,2.076,2.076,0,0,1,.358.372.37.37,0,0,1,.025.307C26.97,24.419,26.852,24.471,26.771,24.537Z",
    transform: "translate(-12.016 -12.355)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_443",
    "data-name": "Trazado 443",
    d: "M15.765,24.6a.3.3,0,0,1,.293.31.315.315,0,0,1-.312.3.324.324,0,0,1-.3-.316A.311.311,0,0,1,15.765,24.6Z",
    transform: "translate(-8.08 -12.731)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_444",
    "data-name": "Trazado 444",
    d: "M24.195,24.9a.324.324,0,0,1-.3.308.314.314,0,0,1-.3-.3.3.3,0,0,1,.3-.3A.312.312,0,0,1,24.195,24.9Z",
    transform: "translate(-11.079 -12.731)",
    fill: "#5a5a5a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnoLiturgico);
export default __webpack_public_path__ + "static/media/ic_ano_liturgico.6faa533a9c5eae77c0d4cbdbb07ab1d4.svg";
export { ForwardRef as ReactComponent };